import {
  FormControl,
  FormErrorMessage,
  FormLabel,
} from "@chakra-ui/form-control";
import type { ComponentProps } from "react";
import React from "react";
import type { FieldValues, UseFormReturn } from "react-hook-form";

interface IFormInputWraperProps extends ComponentProps<any> {
  field_name: string;
  label?: string;
  color: string;
  FormController: UseFormReturn<FieldValues, object>;
  isRequired?: boolean;
}

const FormInputWraper = ({
  field_name,
  label,
  color,
  children,
  FormController,
  isRequired = false,
  ...props
}: IFormInputWraperProps) => (
  <FormControl
    isRequired={isRequired}
    isInvalid={!!FormController.formState.errors[field_name]}
    {...props}
  >
    {label && (
      <FormLabel whiteSpace="nowrap" flex="1" color={color}>
        {label}
      </FormLabel>
    )}
    {children}
    <FormErrorMessage>
      {FormController.formState.errors[field_name]?.message}
    </FormErrorMessage>
  </FormControl>
);

export default FormInputWraper;
